import { render } from "./GameSuggestionsAndFeedback.vue?vue&type=template&id=1222ed20&scoped=true"
import script from "./GameSuggestionsAndFeedback.vue?vue&type=script&lang=js"
export * from "./GameSuggestionsAndFeedback.vue?vue&type=script&lang=js"

import "./GameSuggestionsAndFeedback.vue?vue&type=style&index=0&id=1222ed20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1222ed20"]])

export default __exports__